<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" @show="onShow" :title="computedTitle"
                   @hidden="onHidden" :show-confirmation="showConfirmation" @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12" v-if="sale && sale.auction_collections">
          <auction-collection-select-input-widget :model="model" attribute="auction_collection_uuid"
                                                  :items="sale.auction_collections" hint/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import LotsService from "@/modules/lots/LotsService";
  import {SOURCE_LOTS_TABLE} from "@/modules/constants";
  import AuctionCollectionSelectInputWidget from "@/core/widgets/AuctionCollectionSelectInputWidget";
  import BatchCollectionUpdateModel
    from "@/modules/lots/batch-collection-update-modal/BatchCollectionUpdateModel.model";

  const {mapState, mapActions} = createNamespacedHelpers('lots');

  export default {
    name: "BatchCollectionUpdateModal",
    components: {
      AuctionCollectionSelectInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new BatchCollectionUpdateModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.batchCollectionUpdateModal,
        reservations: state => state.batchCollectionUpdateModal.reservations,
        sale: state => state.batchCollectionUpdateModal.sale,
      }),
      computedTitle() {
        return this.$i18n.t("Batch Collection Update")
      }
    },
    methods: {
      ...mapActions(['hideBatchCollectionUpdateModal', 'getTableData']),
      onShow() {
        this.showConfirmation = true;
        this.model = new BatchCollectionUpdateModel();
      },
      onHidden() {
        this.hideBatchCollectionUpdateModal();
      },
      async onSubmit() {

        if (!this.model.auction_collection_uuid) {
          let success = await this.$confirm("Are you sure you want to remove collection for all items?")
          if (!success) {
            return;
          }
        }

        let requestData = {
          auction_collection_uuid: this.model.auction_collection_uuid === '' ? null : this.model.auction_collection_uuid,
          auction_uuid: this.sale.uuid,
          lot_uuids: this.reservations.map(r => r.lot.uuid)
        }

        this.showConfirmation = false
        let response = await LotsService.batchUpdateLotCollection(requestData)
        if (response.success) {
          if (this.modal.source === SOURCE_LOTS_TABLE) {
            this.$toast('success', this.$i18n.t("Collection for lot(s) was successfully updated"))
            this.getTableData()
            this.hideBatchCollectionUpdateModal()
          }
        } else {
          this.showConfirmation = true
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body)
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
